import React from "react";
import { Col, Modal, ModalFooter, Row } from "react-bootstrap";
import { Button, DropDown } from "../../components";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { toast } from "react-toastify";
const SessionFilterModal = (props: any) => {
  const {
    show,
    handleClose,
    handleFilterSubmit,
    sportName,
    setSportName,
    sessionstatus,
    setSessionStatus,
  } = props;
  const { sessionStatus } = useAppSelector(
    (state: any) => state.enumsArray.Enums
  );
  const { AllSportsData  , sportErrorMessage} = useAppSelector((state: any) => state.sportList);

  const SessionStatusKey: string[] = Object?.values(sessionStatus) || [];
  const SessionStatusValues: string[] = Object?.keys(sessionStatus) || [];
  if (sportErrorMessage) {
    toast.error(sportErrorMessage.message)
  }
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="border-0 pb-0 pb-2" closeButton>
        <Modal.Title id="contained-modal-title-vcenter fw-semibold">
          Filter
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col lg={6}>
            <div className="mb-3">
              <label htmlFor="sports" className="form-label">
                Sport Name
              </label>
              <DropDown
                id="sports"
                name="sports"
                value={sportName}
                onChange={(e: any) => setSportName(e.target.value)}
              >
                <option value="">Select Sport</option>
                {AllSportsData?.map((item: any) => {
                  return (
                    <option key={item?.id} value={`${item.id}`}>
                      {item.name}
                    </option>
                  );
                })}
              </DropDown>
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <label htmlFor="sports" className="form-label">
                Session status
              </label>
              <DropDown
                id="status"
                name="status"
                value={sessionstatus}
                onChange={(e: any) => setSessionStatus(e.target.value)}
              >
                <option value="">Select status</option>
                {SessionStatusKey?.map((item: string, index: number) => {
                  return (
                    <option
                      key={SessionStatusValues[index]}
                      value={SessionStatusValues[index]}
                    >
                      {item}
                    </option>
                  );
                })}
              </DropDown>
            </div>
          </Col>
        </Row>
        <ModalFooter>
          <Col lg={12} className="text-center">
            <Button
              onClick={handleFilterSubmit}
              type="button"
              bname="Submit"
              name="submit"
              id="submit"
              className="btn btn-primary rounded-1 mt-1"
            ></Button>
          </Col>
        </ModalFooter>
      </Modal.Body>
    </Modal>
  );
};

export { SessionFilterModal };
